/**
 * GST summary totals for reports (Region Pack)
 */

import type { GstSummary } from '../../../../types/report.types';

const GST_RATE = 0.1;

function calculateGST(amount: number, isGSTInclusive = true): number {
  if (isGSTInclusive) {
    return amount - amount / (1 + GST_RATE);
  }
  return amount * GST_RATE;
}

export interface GstTransactionLike {
  amount: number;
  category_id?: string | null;
}

export interface GstCategoryLike {
  id: string;
  gst_applicable?: boolean;
}

export function buildGstSummary(
  transactions: GstTransactionLike[],
  categories: GstCategoryLike[]
): GstSummary | null {
  const categoryMap = new Map(categories.map((c) => [c.id, c]));
  let inclusiveTotal = 0;
  let exclusiveTotal = 0;

  for (const tx of transactions) {
    const amount = Math.abs(Number(tx.amount) || 0);
    const cat = tx.category_id ? categoryMap.get(tx.category_id) : undefined;
    if (cat?.gst_applicable) {
      inclusiveTotal += amount;
    } else {
      exclusiveTotal += amount;
    }
  }

  if (inclusiveTotal === 0 && exclusiveTotal === 0) {
    return null;
  }

  const netGst = calculateGST(inclusiveTotal, true);

  return {
    inclusiveTotal,
    exclusiveTotal,
    netGst,
  };
}
